module.exports = __webpack_public_path__ + "media/images/logo_sm_dark-212919d40c4d2d151f4c1142c424e1c5.png";